import { AnalyticsEvent } from '@/lib/analytics/Analytics.constants'
import { buildCollectionPayload, gtm } from '@/lib/analytics/Analytics.utils'

import { ProductCard } from '../ProductCard/ProductCard'

import type { BaseHit, Hit } from 'instantsearch.js'

export const AlgoliaProductCard = ({ hit, collectionHandle, collectionId }: { hit: Hit<BaseHit>; collectionHandle?: string; collectionId?: string }) => {
  const image = hit.image ? { url: hit.image as string, altText: hit.title as string } : undefined
  const collectionTitle = hit.product_type
  const href = hit.handle ? `/products/${hit.handle}` : '#'
  const title = hit.title

  const onClick = () => {
    const payload = buildCollectionPayload({ items: [hit], collectionId, collectionHandle })
    gtm.push(AnalyticsEvent.PRODUCT_SELECTED, payload)
  }

  return <ProductCard title={title} collection={collectionTitle} image={image} link={href} onClick={onClick} />
}
